import { loadingOverlay}  from "vuetify-more-component";


export default {

  // emitters
  props: ['presentacion_usuario'],

  components: {
    loadingOverlay
  },

  data() {
    return {
      copyText: '',
      text: "Copiar",
      loading: false,
    };
  },

  async created() {
    console.log("Vamos a crear el reporte anual");
    console.log(this.presentacion_usuario);
    await this.obtenerReporteAnual();
  },

  watch: {
    presentacion_usuario() {
      console.log("Vamos a crear el reporte anual");
      console.log(this.presentacion_usuario);
      this.obtenerReporteAnual();
    }
  },

  methods: {

    // POST
    async obtenerReporteAnual() {
      try {
        let { fecha_presentacion, usuario_id } = this.presentacion_usuario;
        this.loading = true;
        let r = await this.$store.state.services.administradorService.postReporteAnual({ anio: fecha_presentacion.split("-")[0], usuario_id: usuario_id });
        this.loading = false;
        console.log(r);
      } catch (error) {
        console.log(error);


      }
    },

    async copyCode(item) {
      await navigator.clipboard.writeText(item);
      this.copyText = "Copiado"
    },

    reset() {
      this.copyText = this.text
    },
  },
}